import { ReactNode, forwardRef } from "react";
import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { focusOutline } from "@pages/AdminDashboard/theme/focusOutline";

const { color, radius } = adminTokens;
// The design's app bar and drawer controls: 44px square, the icon in navy
// (SHELL-R31, SHELL-R35).
const buttonSize = 44;

const IconButton = styled.button`
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: ${buttonSize}px;
  height: ${buttonSize}px;
  padding: 0;
  border: 0;
  border-radius: ${radius.pill}px;
  background: transparent;
  color: ${color.navy};
  cursor: pointer;

  &:focus-visible {
    ${focusOutline}
  }
`;

interface ShellIconButtonProps {
  label: string;
  onClick: () => void;
  isExpanded?: boolean;
  children: ReactNode;
}

// An icon-only control of the phone's app bar or drawer, named for a screen reader.
export const ShellIconButton = forwardRef<HTMLButtonElement, ShellIconButtonProps>(
  ({ label, onClick, isExpanded, children }, ref) => (
    <IconButton
      ref={ref}
      type="button"
      aria-label={label}
      aria-expanded={isExpanded}
      onClick={onClick}
    >
      {children}
    </IconButton>
  )
);

ShellIconButton.displayName = "ShellIconButton";
